import {
  MapResultI,
  ProcessResultFilterI,
  ProcessResultI, ProcessResultKanban,
  ProcessResultPaginatorI,
  ProcessResultTab, SearchParameters,
  ViewComponentType
} from "../../interfaces/process-result.interface";
import {DetailTabs, TaskI} from "../../interfaces/task.interface";
import {TaskStateI} from "../../interfaces/process.interface";


export const processResultFeatureKey = 'processResult';

export const itemsPerPageList = [
  {value: "10", label: "10"},
  {value: "50", label: "50"},
  {value: "100", label: "100"},
]

export const initialProcessResultPaginator = {
  "count": 0,
  "page": 1,
  "limit": 10,
  "previous": null,
  "next": null
}

export const initialProcessStatusFilter: ProcessResultFilterI = {
  isInitial: true,
  tasks: [],
  process_status: [],
  bookmarked: false
}


export const defaultSearchParameters: SearchParameters = {
  initial: true,
  orderBy: null,
  order: null,
  search: null,
  bookmarked_filter: "inactive",
  process_status_filter: "",
  process_tasks_filter: "",
  dynamic_filter: null,
  entries: 10,
  page: 1
}

export interface StateProcessResult {
  paginator: ProcessResultPaginatorI;
  processResultList: ProcessResultI[];
  processResultMap: {
    "count": number,
    "page": number,
    "loaded": number,
    "valid": number,
    "result": MapResultI[][]
  };
  selectedProcessResult: ProcessResultI | null;
  detailProcessResult: ProcessResultI | null;
  loadingResults: boolean;
  loadingBookmarked: boolean;
  loadingCreateResult: boolean;
  loadingResultTaskAction: boolean;
  loadingProcessResultPermissions: boolean;
  loadingProcessResultGridData: boolean;
  loadingDetailProcessResult: boolean;
  loadingProcessResultMap: boolean;
  loadingActionButton: { button: string, status: boolean };
  loadingBulkRemoveProcessResult:boolean;
  loadingBulkStatusProcessResult:boolean;
  loadingBulkStatusTaskResult:string;
  loadingBulkActionButton: string;
  showFilterBar: boolean;
  showRightBar: boolean;
  processResultTab: ProcessResultTab;
  detailTab: DetailTabs;
  viewComponent: ViewComponentType | null;
  processResultKanban: ProcessResultKanban | null;
  processResultFilter: ProcessResultFilterI;
  globalSearch: string;
  gridData: TaskI[];
  gridDefaultState: TaskStateI | null;
  searchParameters: SearchParameters;
  selectedProcessResults: ProcessResultI[];
  bulkRemoveJobId: string;
  bulkStatusJobId: string;
  bulkTaskStatusJobId: string;
}

//ESTADO INICIAL
export const initialState: StateProcessResult = {
  paginator: initialProcessResultPaginator,
  processResultList: [],
  processResultMap: {count: 0, loaded: 0, page: 0, valid: 0, result: []},
  selectedProcessResult: null,
  detailProcessResult: null,
  loadingResults: true,
  loadingBookmarked: false,
  loadingCreateResult: false,
  loadingResultTaskAction: false,
  loadingProcessResultPermissions: false,
  loadingProcessResultGridData: false,
  loadingDetailProcessResult: false,
  loadingProcessResultMap: true,
  loadingActionButton: {button: '', status: false},
  loadingBulkRemoveProcessResult: false,
  loadingBulkStatusProcessResult: false,
  loadingBulkStatusTaskResult: '',
  loadingBulkActionButton: '',
  showFilterBar: false,
  showRightBar: false,
  processResultTab: ProcessResultTab.detail,
  detailTab: DetailTabs.info,
  viewComponent: null,
  processResultKanban: null,
  processResultFilter: initialProcessStatusFilter,
  globalSearch: "",
  gridData: [],
  gridDefaultState: null,
  searchParameters: defaultSearchParameters,
  selectedProcessResults: [],
  bulkRemoveJobId: "",
  bulkStatusJobId: "",
  bulkTaskStatusJobId: ""
};
